import { RemarkButton } from '@Components/IconButton';
import Remark from '@Components/Remark';
import { useDisclosure } from '@hooks/useDisclosure';
import { Box } from '@mui/material';
import { createPortal } from 'react-dom';
import { useWatch } from 'react-hook-form';
import { useGreenhouseForm } from '../EsgGreenhouseFormProvider';
import { IGreenhouseStrategyFormValues } from '../EsgGreenhouseFormProvider/types';

export const GH_STRATEGY_REMARK_ID = 'gh-strategy-remark';

const GreenhouseStrategyRemark = () => {
  const { control, getValues } = useGreenhouseForm();
  const { remark } =
    getValues(`greenhouseStrategy`) ?? ({} as IGreenhouseStrategyFormValues);

  const [isRemarkOpen, { open, close }] = useDisclosure(!!remark);

  const ghGoalTermRemarkEl = document.getElementById(GH_STRATEGY_REMARK_ID);

  const { completedSection } =
    useWatch({
      name: 'greenhouseStrategy',
      control,
    }) ?? ({} as IGreenhouseStrategyFormValues);

  const { isCompletedTh = false, isCompletedEn = false } =
    completedSection ?? {};

  return (
    <>
      <RemarkButton onClick={open} disabled={isCompletedTh && isCompletedEn} />
      {isRemarkOpen &&
        ghGoalTermRemarkEl &&
        createPortal(
          <Box mt={2}>
            <Remark
              onDelete={close}
              topic="การกำหนดกลยุทธ์และแผนการจัดการก๊าซเรือนกระจกให้เป็นไปตามเป้าหมาย"
              setOpen={open}
              fieldPath="greenhouseStrategy.remark"
              isCompletedEn={isCompletedEn}
              isCompletedTh={isCompletedTh}
            />
          </Box>,
          ghGoalTermRemarkEl
        )}
    </>
  );
};

export default GreenhouseStrategyRemark;
